import { Language } from '@lx/language';
import { Amount, Country } from '@lx/shared/data-access/types';
import { CountryWeight } from '../../types';
import { SchoolV4 } from '@lx/shared/data-access/school';
import { CountryRegion, ResidenceCountry } from '@lx/shared/data-access/destination';

/**
 * State with all shared data around the application
 */
export interface SharedDataState {
  languages?: Language[];
  schools?: SchoolV4[];
  countries?: Country[];
  countryWeights?: CountryWeight[];
  currencies?: Amount[];
  residenceCountries?: ResidenceCountry[];
  residenceRegions?: CountryRegion[];
  suggestedPremiumActivityCode?: string;
}
